export default __webpack_public_path__ + "static/media/portfolio-9.561bb1f2.jpg";